module.exports = __webpack_public_path__ + "img/product_without_photo.5ec932a4.png";